import React from "react";
import {Link} from "react-router-dom";
import LogoUrl from '../../assets/img/logo.svg';
import LogoUrlFooter from '../../assets/img/logo_negative.svg';

const ComponentError = ({error, resetErrorBoundary}) => {
    return <>

        <main>
            <div className="section-group pt-5 mt-5">
                <div className="section section-default">

                    <div className="container container-xs text-center">
                        <h1>Nåt gick fel.</h1>

                        <div className="mt-4">Tyvärr uppstod ett fel när sidan skulle laddas. Du kan testa att ladda om sidan i webbläsaren
                            eller
                            kontrollera din internetanslutning. Om problemet kvarstår kan du gå tillbaka till startsidan
                            eller
                            kontakta vår support.<br /><br />
                            <Link to={"/"} className="button button-arrow">Gå tillbaka till startsidan</Link>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    </>
}

export default ComponentError;
